/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/KlondikeTemplate/KlondikeWindowsTemplate',['lodash',
        'pixi',
        'util/eventhandler',
        'Arkadium/GameEngine/Core/EngineManagers',
        'CardUI/SupplyView',
        'CardUI/PileView',
        'CardUI/KeyboardNavigator',
        'SolitaireShared/CardLogic/Supply',
        'SolitaireShared/KlondikeLogic/KlondikeAuthority',
        'SolitaireShared/KlondikeTemplate/KlondikeInputInterpreter',
        'SolitaireShared/KlondikeTemplate/KlondikeCardAnimator',
        'SolitaireShared/CardLogic/CardSuit',
        'SolitaireShared/CardLogic/CardAction',
        'util/SettingsManager',
        'Arkadium/GameEngine/Maths/Vector2',
        'absolute'
    ],
    function (_, PIXI, EventHandler, EngineManagers, SupplyView, PileView, KeyboardNavigator, Supply, KlondikeAuthority, KlondikeInputInterpreter, KlondikeCardAnimator, CardSuit, CardAction, SettingsManager, Vector2, Absolute) {
        var KlondikeWindowsTemplate = function () {
            this.initKlondikeWindowsTemplate();
        };

        KlondikeWindowsTemplate.prototype.initKlondikeWindowsTemplate = function () {
            this._authorityReference = null;
            this._supplyViewReference = null;
            this._curAutoSolveView = null;
            this._curAutoSolveViewOnUpdated = new EventHandler();
            this.settingsManager = SettingsManager;
            this.mobilePileSpacingOffset = 0.3;
            this.defaultPileSpacingOffset = 0.2;
        };

        KlondikeWindowsTemplate.prototype.CreateAuthority = function (challenge) {
            var authority = challenge != null
                ? challenge.ConstructAuthority()
                : new KlondikeAuthority();

            authority.Setup();
            authority.CardSupply.DeckSeed = null;

            this._authorityReference = authority;
            return authority;
        };

        KlondikeWindowsTemplate.prototype.Cleanup = function () {
            //TODO EngineManagers.Input.MouseDown -= InputManager_OnMouseDown;
            this._supplyViewReference.OnMoveCardsEvent.remove(this.OnMoveCardsHandler);
            this._authorityReference = null;
            this._supplyViewReference = null;
        };

        KlondikeWindowsTemplate.prototype.CreateInputInterpreter = function (authority) {
            return new KlondikeInputInterpreter(authority);
        };

        KlondikeWindowsTemplate.prototype.CreateCardAnimator = function (supplyView) {
            //TODO EngineManagers.Input.MouseDown += InputManager_OnMouseDown;

            return new KlondikeCardAnimator(supplyView);
        };

        KlondikeWindowsTemplate.prototype.InputManager_OnMouseDown = function (pointEvent) {
            if (this._supplyViewReference != null /* TODO - middle? && pointEvent.Point.MiddlePressed */) {
                this.TryAutoSolve(this._supplyViewReference);
            }
        };

        KlondikeWindowsTemplate.SuitMap = ["none", "clubs", "diamonds", "hearts", "spades"];

        KlondikeWindowsTemplate.prototype.TryAutoSolve = function (supplyView) {
            var numFoundations = 4;

            if (this._authorityReference != null && true) {
                var suitToFoundation = {};

                // Figure out which suits go to which foundations
                var suitsToInsert = [CardSuit.Hearts, CardSuit.Diamonds, CardSuit.Clubs, CardSuit.Spades];

                _.times(numFoundations, function (index) {
                    var foundationPile = supplyView.CardSupply.GetPile("Foundation" + index);
                    if (!foundationPile.Empty) {
                        var suit = foundationPile.Top.Suit;
                        suitToFoundation[KlondikeWindowsTemplate.SuitMap[suit]] = foundationPile;
                        _.pull(suitsToInsert, suit);
                    }

                }, this);

                if (suitsToInsert.length > 0) {
                    _.times(numFoundations, function (index) {
                        var foundationPile = supplyView.CardSupply.GetPile("Foundation" + index);
                        if (foundationPile.Empty) {
                            var suitId = suitsToInsert[0];
                            var suit = KlondikeWindowsTemplate.SuitMap[suitId];
                            suitToFoundation[suit] = foundationPile;
                            _.pull(suitsToInsert, suitId);
                        }

                    }, this);
                }

                var autoMoveInterval = 100,
                    timeSinceLastAutoMove = 0;

                this._curAutoSolveView = supplyView;

                this._curAutoSolveViewOnUpdated = function (sender, gameTime) {

                    if (this._curAutoSolveView == null) {
                        return false;
                    }

                    timeSinceLastAutoMove += gameTime.ElapsedGameTime.Milliseconds;
                    if (timeSinceLastAutoMove > autoMoveInterval) {
                        timeSinceLastAutoMove = 0;

                        if (this.AutoSolveDoNextMove(suitToFoundation)) {
                            this._curAutoSolveView.OnMoveCards();
                        } else {
                            this.StopAutoSolving();
                        }
                    }

                }.bind(this);

                this._curAutoSolveView.Updated.add(this._curAutoSolveViewOnUpdated);

            }

        };

        KlondikeWindowsTemplate.prototype.StopAutoSolving = function () {
            if (this._curAutoSolveView != null) {
                // TODO this._curAutoSolveView.Updated -= _curAutoSolveViewOnUpdated;
                this._curAutoSolveView.Updated.remove(this._curAutoSolveViewOnUpdated);
                this._curAutoSolveView = null;
                this._curAutoSolveViewOnUpdated = null;
            }
        };

        KlondikeWindowsTemplate.prototype.AutoSolveDoNextMove = function (suitToFoundation) {
            // note: @jarbot ported this so it is proly fubar^2.

            var numTableaus = 7;


            /*if (suitToFoundation[CardSuit.Hearts].Count < 13 || suitToFoundation[CardSuit.Clubs].Count < 13 ||
                suitToFoundation[CardSuit.Diamonds].Count < 13 || suitToFoundation[CardSuit.Spades].Count < 13)*/
            if (suitToFoundation['hearts'].Count < 13 || suitToFoundation['clubs'].Count < 13 ||
                suitToFoundation['diamonds'].Count < 13 || suitToFoundation['spades'].Count < 13) {
                var action = new CardAction(this._authorityReference.CardSupply);
                // Check Waste
                var sourcePile = this._authorityReference.CardSupply.GetPile("Waste"),
                    destinationPile;

                if (!sourcePile.Empty) {
                    destinationPile = suitToFoundation[KlondikeWindowsTemplate.SuitMap[sourcePile.Top.Suit]];
                    if (destinationPile) {
                        this._supplyViewReference.GameInputInterpreter.DoMoveCard(sourcePile.Top, sourcePile, destinationPile, action);

                        if (action.Run(false)) {
                            EngineManagers.Sounds.PlaySound("foundation");
                            return true;
                        }
                    }
                }

                // Iterate through Tableaus
                for (var i = 0; i < numTableaus; i++) {
                    sourcePile = this._authorityReference.CardSupply.GetPile("Tableau" + i);
                    if (!sourcePile.Empty) {
                        //destinationPile = suitToFoundation[sourcePile.Top.Suit];
                        destinationPile = suitToFoundation[KlondikeWindowsTemplate.SuitMap[sourcePile.Top.Suit]];
                        if (destinationPile) {
                            this._supplyViewReference.GameInputInterpreter.DoMoveCard(sourcePile.Top, sourcePile, destinationPile, action);
                            if (action.Run(false)) {
                                EngineManagers.Sounds.PlaySound("foundation");
                                return true;
                            } else {
                            }
                        }
                    }
                }
            }

            return false;


        };

        KlondikeWindowsTemplate.prototype.switchLayoutDirection = function (direction) {
            this._supplyViewReference = supplyView;
            var width = EngineManagers.Display.Width;
            var height = EngineManagers.Display.Height;

            // reset all keyboard handlers
            _.forEach(supplyView.CardSupply.GetPileList(), function (p) {
                if (p != null) {
                    var pileView = supplyView.GetPileView(p);
                    if (pileView != null)
                        pileView.Keyboard.ResetKeypressHandlers();
                }
            }, this);

            var pile;
            var pileScale = 1.0;
            var cardScale = 1.0;
            var rowScale = .75;

            var topRow = .19 - .5;
            var facedownRow = .42 - .5;
            var tabRow = facedownRow;
            var col = [
                (2 / 16 - .5) * rowScale,
                (4 / 16 - .5) * rowScale,
                (6 / 16 - .5) * rowScale,
                (8 / 16 - .5) * rowScale,
                (10 / 16 - .5) * rowScale,
                (12 / 16 - .5) * rowScale,
                (14 / 16 - .5) * rowScale
            ];

            pile = supplyView.GetPileView("Root");
            pile.LogicalScreenPos = new Vector2(col[0] - 99, topRow - 99);
            pile.DefaultPileSpacing = new Vector2(0, 0);
            pile.CardFacing = PileView.Facing.FaceDown;

            pile = supplyView.GetPileView("Stock");
            pile.LogicalScreenPos = new Vector2(direction === '1' ? col[0] : col[6], topRow);
            pile.DefaultPileSpacing = new Vector2(0, 0);
            pile.DisplayType = PileView.Display.Circle;
            pile.KeyboardMode = PileView.KeyboardModes.TopCardAndEmpty;

            pile.Keyboard.ResetKeypressHandlers();

            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Waste"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Foundation0"));


            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau0"));

            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Waste"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Foundation0"));

            pile = supplyView.GetPileView("Waste");
            pile.LogicalScreenPos = new Vector2(direction === '1' ? col[1] : col[4] + 0.045, topRow);
            pile.PileMode = PileView.Layout.FanRight;            
            if (Absolute.Platform.isMobile())
                pile.DefaultPileSpacing = new Vector2(this.mobilePileSpacingOffset, 0);
            else
                pile.DefaultPileSpacing = new Vector2(this.defaultPileSpacingOffset, 0);
            pile.DisplayType = PileView.Display.Blank;
            pile.KeyboardMode = PileView.KeyboardModes.TopCard;
            pile.Keyboard.ResetKeypressHandlers();

            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Foundation0"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Stock"));

            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau1"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau1"));

            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Foundation0"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Stock"));

            for (var i = 0; i < 7; i++) {
                pile = supplyView.GetPileView("FaceDown" + i);

                pile.PileMode = PileView.Layout.FanDown;
                pile.LogicalScreenPos = new Vector2(col[i], facedownRow);
                pile.DefaultPileSpacing = new Vector2(0, 0.10);
            }

            for (var i = 0; i < 7; i++) {
                pile = supplyView.GetPileView("Tableau" + i);
                pile.PileMode = PileView.Layout.FanDown;
                pile.LogicalScreenPos = new Vector2(col[i], tabRow);
                pile.DefaultPileSpacing = new Vector2(0, 0.24);
                pile.DisplayType = PileView.Display.Blank;
                pile.HeightLimit = 0.97;
                pile.KeyboardMode = PileView.KeyboardModes.AllCardsAndEmpty;
                pile.Keyboard.ResetKeypressHandlers();

                if (i == 0) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Stock"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau1"));
                } else if (i == 1) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Waste"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Stock"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Waste"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Stock"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau0"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau2"));
                } else if (i == 2) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Waste"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Stock"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Waste"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Stock"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau1"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau3"));
                } else if (i == 3) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Foundation0"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Foundation0"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau2"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau4"));
                } else if (i == 4) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Foundation1"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Foundation1"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau3"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau5"));
                } else if (i == 5) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Foundation2"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Foundation2"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau4"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau6"));
                } else if (i == 6) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Foundation3"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau5"));
                }

                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Foundation0"));

            }

            for (var i = 0; i < 4; i++) {
                pile = supplyView.GetPileView("Foundation" + i);

                pile.LogicalScreenPos = new Vector2(col[i + 3], topRow);
                pile.DefaultPileSpacing = new Vector2(0, 0);
                pile.DisplayType = PileView.Display.Tableau;

                pile.KeyboardMode = PileView.KeyboardModes.TopCardAndEmpty;
                pile.Keyboard.ResetKeypressHandlers();

                if (i == 0) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau3"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau3"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Waste"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Stock"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Foundation1"));
                } else if (i == 1) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau4"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau4"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Foundation0"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Foundation2"));
                } else if (i == 2) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau5"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau5"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Foundation1"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Foundation3"));
                } else if (i == 3) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau6"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Foundation2"));
                }

                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Waste"));
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Stock"));
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Tableau0"));

            }
            supplyView.DefaultKeyboardFocus = supplyView.GetPileView("Stock");

            supplyView.CardScale = cardScale;

            pile = supplyView.GetPileView("Root");
            pile.CardFacing = PileView.Facing.Hidden;
            pile.PileMode = PileView.Layout.Pile;
            pile.InteractionMode = PileView.Interaction.None;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;

            pile = supplyView.GetPileView("Stock");
            pile.CardFacing = PileView.Facing.FaceDown;
            pile.PileMode = PileView.Layout.Pile;
            pile.InteractionMode = PileView.Interaction.Click;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;

            pile = supplyView.GetPileView("Waste");
            pile.CardFacing = PileView.Facing.FaceUp;
            pile.InteractionMode = PileView.Interaction.Drag;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;
            pile.FanLimit = (supplyView.CardSupply.GetOption("Draw") == "3") ? 3 : 1;

            for (var i = 0; i < 7; i++) {
                pile = supplyView.GetPileView("Tableau" + i);

                pile.CardFacing = PileView.Facing.FaceUp;
                pile.InteractionMode = PileView.Interaction.Drag;
                pile.StackedPile = supplyView.GetPileView("FaceDown" + i);
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
            }

            for (var i = 0; i < 7; i++) {
                pile = supplyView.GetPileView("FaceDown" + i);

                pile.CardFacing = PileView.Facing.FaceDown;
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
            }

            for (var i = 0; i < 4; i++) {
                pile = supplyView.GetPileView("Foundation" + i);

                pile.CardFacing = PileView.Facing.FaceUp;
                pile.PileMode = PileView.Layout.Pile;
                pile.InteractionMode = PileView.Interaction.Drag;
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
            }

            // TODO supplyView.OnMoveCardsEvent -= SupplyView_OnMoveCards;
            this.OnMoveCardsHandler = this.SupplyView_OnMoveCards.bind(this);
            supplyView.OnMoveCardsEvent.add(this.OnMoveCardsHandler);

            var stock = supplyView.GetPileView("Stock");
            var gameType = this._authorityReference.CardSupply.GetOption("Scoring");

            if (this._authorityReference.PassesThroughDeck > 1 &&
                (gameType == KlondikeAuthority.LAS_VEGAS || gameType == KlondikeAuthority.LAS_VEGAS_CUMULATIVE)) {
                if (stock.DisplayType != PileView.Display.X) {
                    stock.DisplayType = PileView.Display.X;
                }

            }
        }


        KlondikeWindowsTemplate.prototype.DoLayoutPiles = function (renderManager, supplyView) {
            var isLeft = SettingsManager.getSetting('klondike', 'layoutDirection') === '1';
            this._supplyViewReference = supplyView;
            var width = EngineManagers.Display.Width;
            var height = EngineManagers.Display.Height;

            // reset all keyboard handlers
            _.forEach(supplyView.CardSupply.GetPileList(), function (p) {
                if (p != null) {
                    var pileView = supplyView.GetPileView(p);
                    if (pileView != null)
                        pileView.Keyboard.ResetKeypressHandlers();
                }
            }, this);

            var pile;
            var pileScale = 1.0;
            var cardScale = 1.0;
            var rowScale = .75;

            var topRow = .19 - .5;
            var facedownRow = .42 - .5;
            var tabRow = facedownRow;
            var col = [
                (2 / 16 - .5) * rowScale,
                (4 / 16 - .5) * rowScale,
                (6 / 16 - .5) * rowScale,
                (8 / 16 - .5) * rowScale,
                (10 / 16 - .5) * rowScale,
                (12 / 16 - .5) * rowScale,
                (14 / 16 - .5) * rowScale
            ];

            pile = supplyView.GetPileView("Root");
            pile.LogicalScreenPos = new Vector2(col[0] - 99, topRow - 99);
            pile.DefaultPileSpacing = new Vector2(0, 0);
            pile.CardFacing = PileView.Facing.FaceDown;

            pile = supplyView.GetPileView("Stock");
            pile.LogicalScreenPos = new Vector2(isLeft ? col[0] : col[6], topRow);
            pile.DefaultPileSpacing = new Vector2(0, 0);
            pile.DisplayType = PileView.Display.Circle;
            pile.KeyboardMode = PileView.KeyboardModes.TopCardAndEmpty;

            pile.Keyboard.ResetKeypressHandlers();

            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Waste"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Foundation0"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau0"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Waste"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Foundation0"));

            pile = supplyView.GetPileView("Waste");
            pile.LogicalScreenPos = new Vector2(isLeft ? col[1] : col[4] + 0.045, topRow);
            pile.PileMode = PileView.Layout.FanRight;
            if (Absolute.Platform.isMobile())
                pile.DefaultPileSpacing = new Vector2(this.mobilePileSpacingOffset, 0);
            else
                pile.DefaultPileSpacing = new Vector2(this.defaultPileSpacingOffset, 0);
            pile.DisplayType = PileView.Display.Blank;
            pile.KeyboardMode = PileView.KeyboardModes.TopCard;
            pile.Keyboard.ResetKeypressHandlers();

            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Foundation0"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Stock"));

            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau1"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau1"));

            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Foundation0"));
            pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Stock"));

            for (var i = 0; i < 7; i++) {
                pile = supplyView.GetPileView("FaceDown" + i);

                pile.PileMode = PileView.Layout.FanDown;
                pile.LogicalScreenPos = new Vector2(col[i], facedownRow);

                if (Absolute.Platform.isMobile())
                    pile.DefaultPileSpacing = new Vector2(0, 0.15);
                else
                    pile.DefaultPileSpacing = new Vector2(0, 0.10);
            }

            for (var i = 0; i < 7; i++) {
                pile = supplyView.GetPileView("Tableau" + i);
                pile.PileMode = PileView.Layout.FanDown;
                pile.LogicalScreenPos = new Vector2(col[i], tabRow);

                pile.DefaultPileSpacing = new Vector2(0, 0.24);
                pile.DisplayType = PileView.Display.Blank;
                pile.HeightLimit = 0.97;
                
                if (Absolute.Platform.isMobile() && !Absolute.ScreenMetrics.isPortrait()) {
                    pile.DefaultPileSpacing = new Vector2(0, 0.35);

                    if (this._authorityReference.IsChallenge)
                        pile.HeightLimit = 0.77;
                    else
                        pile.HeightLimit = 0.8;
                }

                
                pile.KeyboardMode = PileView.KeyboardModes.AllCardsAndEmpty;
                pile.Keyboard.ResetKeypressHandlers();

                if (i == 0) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Stock"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau1"));
                } else if (i == 1) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Waste"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Stock"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Waste"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Stock"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau0"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau2"));
                } else if (i == 2) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Waste"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Stock"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Waste"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Stock"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau1"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau3"));
                } else if (i == 3) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Foundation0"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Foundation0"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau2"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau4"));
                } else if (i == 4) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Foundation1"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Foundation1"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau3"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau5"));
                } else if (i == 5) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Foundation2"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Foundation2"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau4"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau6"));
                } else if (i == 6) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Foundation3"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau5"));
                }

                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Foundation0"));

            }

            for (var i = 0; i < 4; i++) {
                pile = supplyView.GetPileView("Foundation" + i);

                pile.LogicalScreenPos = new Vector2(isLeft ? col[i + 3] : col[i], topRow);
                pile.DefaultPileSpacing = new Vector2(0, 0);
                pile.DisplayType = PileView.Display.Tableau;

                pile.KeyboardMode = PileView.KeyboardModes.TopCardAndEmpty;
                pile.Keyboard.ResetKeypressHandlers();

                if (i == 0) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau3"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau3"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Waste"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Stock"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Foundation1"));
                } else if (i == 1) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau4"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau4"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Foundation0"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Foundation2"));
                } else if (i == 2) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau5"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau5"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Foundation1"));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Foundation3"));
                } else if (i == 3) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau6"));

                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Foundation2"));
                }

                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Waste"));
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Stock"));
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Tableau0"));

            }

            supplyView.DefaultKeyboardFocus = supplyView.GetPileView("Stock");

            supplyView.CardScale = cardScale;

            pile = supplyView.GetPileView("Root");
            pile.CardFacing = PileView.Facing.Hidden;
            pile.PileMode = PileView.Layout.Pile;
            pile.InteractionMode = PileView.Interaction.None;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;

            pile = supplyView.GetPileView("Stock");
            pile.CardFacing = PileView.Facing.FaceDown;
            pile.PileMode = PileView.Layout.Pile;
            pile.InteractionMode = PileView.Interaction.Click;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;

            pile = supplyView.GetPileView("Waste");
            pile.CardFacing = PileView.Facing.FaceUp;
            pile.InteractionMode = PileView.Interaction.Drag;
            pile.ScaleX = pileScale;
            pile.ScaleY = pileScale;
            pile.FanLimit = (supplyView.CardSupply.GetOption("Draw") == "3") ? 3 : 1;

            for (var i = 0; i < 7; i++) {
                pile = supplyView.GetPileView("Tableau" + i);

                pile.CardFacing = PileView.Facing.FaceUp;
                pile.InteractionMode = PileView.Interaction.Drag;
                pile.StackedPile = supplyView.GetPileView("FaceDown" + i);
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
            }

            for (var i = 0; i < 7; i++) {
                pile = supplyView.GetPileView("FaceDown" + i);

                pile.CardFacing = PileView.Facing.FaceDown;
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
            }

            for (var i = 0; i < 4; i++) {
                pile = supplyView.GetPileView("Foundation" + i);

                pile.CardFacing = PileView.Facing.FaceUp;
                pile.PileMode = PileView.Layout.Pile;
                pile.InteractionMode = PileView.Interaction.Drag;
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
            }

            // TODO supplyView.OnMoveCardsEvent -= SupplyView_OnMoveCards;
            this.OnMoveCardsHandler = this.SupplyView_OnMoveCards.bind(this);
            supplyView.OnMoveCardsEvent.add(this.OnMoveCardsHandler);

            var stock = supplyView.GetPileView("Stock");
            var gameType = this._authorityReference.CardSupply.GetOption("Scoring");

            if (this._authorityReference.PassesThroughDeck > 1 &&
                (gameType == KlondikeAuthority.LAS_VEGAS || gameType == KlondikeAuthority.LAS_VEGAS_CUMULATIVE)) {
                if (stock.DisplayType != PileView.Display.X) {
                    stock.DisplayType = PileView.Display.X;
                }
            }
        };

        KlondikeWindowsTemplate.prototype.SupplyView_OnMoveCards = function (supply) {
            var stock = supply.GetPileView("Stock");
            var gameType = this._authorityReference.CardSupply.GetOption("Scoring");

            if (this._authorityReference.PassesThroughDeck > 1 &&
                (gameType == KlondikeAuthority.LAS_VEGAS || gameType == KlondikeAuthority.LAS_VEGAS_CUMULATIVE)) {
                if (stock.Pile.Empty && stock.DisplayType != PileView.Display.X) {
                    setTimeout(function () {
                        stock.DisplayType = PileView.Display.X;
                    }.bind(this), 250);
                }
            } else {
                stock.DisplayType = PileView.Display.Circle;
            }
        };

        KlondikeWindowsTemplate.prototype.LoadGameOptions = function (supply, resetCumulativeScoring) {
            this._checkAndImportOldCumulativeScore();
            supply.SetOption("Draw", this.settingsManager.getSetting('klondike', 'cardsPerDraw'));

            var scoringType = this.settingsManager.getSetting('klondike', 'scoringType');

            supply.UseCumulativeScoring = scoringType == "LASVEGASCUMULATIVE";
            supply.SetOption("Scoring", scoringType);
            supply.SetOption("KlondikeTimer", this.settingsManager.getSetting('klondike', 'timer') ? "true" : "false");

            if (this.settingsManager.getSetting('klondike', 'difficulty') === undefined) {
                this.settingsManager.setSetting('klondike', 'difficulty', "RANDOM");
            }

            supply.SetOption("Difficulty", this.settingsManager.getSetting('klondike', 'difficulty'));

            if (this.settingsManager.getSetting('klondike', 'layoutDirection') === undefined) {
                this.settingsManager.setSetting('klondike', 'layoutDirection', '1');
            }

            var score = this.settingsManager.getSetting(
                'klondike', 'cumulativeScoreForDraw' + supply.GetOption("Draw")
            );
            if (_.isNumber(score) && !resetCumulativeScoring) {
                supply.CumulativeScore = parseInt(score);
                supply.SetOption("CumulativeScore", score);
            }

            if (resetCumulativeScoring) {
                this.SaveGameOptions(supply);
            }

        };

        KlondikeWindowsTemplate.prototype.SaveGameOptions = function (supply) {
            if (supply.UseCumulativeScoring) {
                this.settingsManager.setSetting(
                    "klondike", "cumulativeScoreForDraw" + supply.GetOption("Draw"), supply.CumulativeScore
                );
            }
        };

        Object.defineProperty(KlondikeWindowsTemplate.prototype, "EndGameStatStrings",
            {
                get: function () {
                    var useTimer = this._authorityReference.CardSupply.GetOption("KlondikeTimer").toLowerCase() == "true";
                    var retval = ["Time"];

                    if (useTimer)
                        retval.push("Time Bonus");

                    retval.push("Score");

                    return retval;
                }
            });

        KlondikeWindowsTemplate.prototype.GetEndGameStats = function () {
            var bonus = this._authorityReference.GetScoreForTimer(this._authorityReference.CardSupply.CurrentTime, 0);
            var useTimer = this._authorityReference.CardSupply.GetOption("KlondikeTimer").toLowerCase() == "true";

            var retval = [
                this._authorityReference.CardSupply.CurrentTime.toString()
            ];

            if (useTimer)
                retval.push(
                    //String.Format("{0:n0}", bonus)
                    bonus
                );

            retval.push(
                // TODO "{0:n0}", _authorityReference.CardSupply.Score + bonus)
                this._authorityReference.CardSupply.Score + bonus
            );

            return retval;
        };

        Object.defineProperty(KlondikeWindowsTemplate.prototype, "SaveFilename", {
            get: function () {
                return "KLONDIKE_SAVE_FILE";
            }
        });

        Object.defineProperty(KlondikeWindowsTemplate.prototype, "GameName", {
            get: function () {
                return "Klondike";
            }
        });

        Object.defineProperty(KlondikeWindowsTemplate.prototype, "DrawOptionKey", {
            get: function () {
                return "APPDATA_KLONDIKE_DRAW";
            }
        });

        Object.defineProperty(KlondikeWindowsTemplate.prototype, "ScoringOptionKey", {
            get: function () {
                return "APPDATA_KLONDIKE_SCORING";
            }
        });

        Object.defineProperty(KlondikeWindowsTemplate.prototype, "CumulativeScoreOptionKey", {
            get: function () {
                return "APPDATA_KLONDIKE_CUMULATIVESCORE";
            }
        });

        Object.defineProperty(KlondikeWindowsTemplate.prototype, "TimerOptionKey", {
            get: function () {
                return "APPDATA_KLONDIKE_TIMER";
            }
        });

        KlondikeWindowsTemplate.prototype._checkAndImportOldCumulativeScore = function() {
            var oldScore = this.settingsManager.getSetting('klondike', 'cumulativeScore');
            if (!_.isNumber(oldScore)) return;
            var scoreDraw1 = this.settingsManager.getSetting('klondike', 'cumulativeScoreForDraw1'),
                scoreDraw3 = this.settingsManager.getSetting('klondike', 'cumulativeScoreForDraw3');
            if (_.isNumber(scoreDraw1) && _.isNumber(scoreDraw3)) return;
            this.settingsManager.setSetting('klondike', 'cumulativeScoreForDraw1', oldScore);
            this.settingsManager.setSetting('klondike', 'cumulativeScoreForDraw3', oldScore);
            this.settingsManager.save();
        };

        return KlondikeWindowsTemplate;
    }
);

